import type { ServiceQualificationAddress } from '@t/serviceQualification.types';
import { formatStreetWithUnit } from '@utils/formatStreetWithUnit';

export const formatStructuredAddress = (address: Partial<ServiceQualificationAddress>): string => {
  const streetWithUnit = formatStreetWithUnit(address.streetNumber, address.streetName, address.unitNumber);
  const provincePostal = `${address.province ?? ''} ${address.postalCode ?? ''}`.trim();
  return [streetWithUnit, address.city, provincePostal, address.country].filter(Boolean).join(', ');
};
